// 模块的GIS逻辑
import Service from '../../../service/ServiceFactory';

const componentBase = (G as any).base.ComponentBase;
const component = componentBase.extend({
    // 属性
    options: {
        highLightId: 'demo_comp', // 高亮id
        tempHighLightId: 'temp_highlight',
        popupId: 'popup_demo_comp', // 弹窗唯一标识
        msgId: 'msg_popup',
        popupEventName: 'popup', // 详情框事件名
        featureType: 'demo_comp', // 图层标识
    },

    /**
     * 示例--创建egis服务，需要导入Service模块
     */
    createWRGSService() {
        return Service.createService('RestWRGSService', {}, this.options.serviceConfig.egis);
    },
    // 初始化
    initialize(options: any) {
        componentBase.prototype.initialize.call(this, options);
        this.wrgsService = this.wrgsService || this.createWRGSService();
        this.linearLayer = new egis.carto.ElementLayer({
            name: 'demoLinearLayer',
        });
        this.map.addLayer(this.linearLayer);
    },

    display_linear() {
        // 创建一个空的Polygon对象
        const polygon = new egis.sfs.Polygon({
            spatialReference: egis.sfs.EnumSpatialReference.EPSG4490,
        });
        // 创建一个ring对象
        const ring = new egis.sfs.Ring({
            spatialReference: egis.sfs.EnumSpatialReference.EPSG4490,
        });
        // 将点添加到ring
        ring.addPoint(new egis.sfs.Point({
            x: 116.3476,
            y: 39.87030,
            spatialReference: 4490,
        }));
        ring.addPoint(new egis.sfs.Point({
            x: 116.3576,
            y: 39.87630,
            spatialReference: 4490,
        }));
        ring.addPoint(new egis.sfs.Point({
            x: 116.3576,
            y: 39.88630,
            spatialReference: 4490,
        }));
        // 将环闭合
        ring.close();
        // 将ring添加到polygo中
        polygon.addGeometry(ring);
        // 创建StopCollection对象
        const stopCollection = new egis.sfs.StopCollection();
        const stop1 = new egis.sfs.Stop({
            step: 0.5,
            color: new egis.sfs.Color({ r: 0, g: 255, b: 0, a: 255 }),
        });
        const stop2 = new egis.sfs.Stop({
            step: 0.8,
            color: new egis.sfs.Color({ r: 255, g: 0, b: 0, a: 255 }),
        });
        stopCollection.addStop(stop1);
        stopCollection.addStop(stop2);

        // 创建LinearGradientFillSymbol对象
        const linearGradientFillSymbol = new egis.sfs.LinearGradientFillSymbol({
            stops: stopCollection,
        });
        // 创建线性渐变面元素
        const linearElement = new egis.sfs.Element({
            geometry: polygon,
            symbol: linearGradientFillSymbol,
        });
        this.linearLayer.add(linearElement);
        this.map.pan(polygon);
    },
    //  销毁
    destroy() {
        componentBase.prototype.destroy.call(this);
    },

    unload() {
        componentBase.prototype.unload.call(this);
    },
});

export default component;
